/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Savechangessuccess2Inputs */

const en_common_savechangessuccess2 = /** @type {(inputs: Common_Savechangessuccess2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes saved successfully`)
};

/**
* | output |
* | --- |
* | "Changes saved successfully" |
*
* @param {Common_Savechangessuccess2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_savechangessuccess2 = /** @type {((inputs?: Common_Savechangessuccess2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Savechangessuccess2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_savechangessuccess2(inputs)
});
export { common_savechangessuccess2 as "common_saveChangesSuccess" }